import React, { ReactNode, useCallback } from 'react';

import { CartLayout } from '@sharedComponents/Layout';
import { ReactFCV } from '@types';
import { preventDefaultMouseEvent } from '@utils/general';

import {
  AdditionalColumn,
  BodyColumn,
  IconColumn,
  InfoColumn,
  PriceColumn,
  PerPieceColumn,
  PiecesColumn,
} from './componentHelpers';

interface IServiceItemProps extends IServiceTestProps {
  title: JSX.Element | string;
  infoText: JSX.Element | string | ReactNode;
  serviceActive: boolean;
  serviceDisabled: boolean;
  onClick: () => void;
  onBodyClick?: () => void;
  price?: number;
  pieces?: number;
  unit?: string;
  pricePerPiece?: number;
  additionalInfoComponent?: JSX.Element | ReactNode;
  freePriceText?: JSX.Element | string;
  isDualPriceLayout: boolean;
  dataTestId?: string;
}

interface IServiceTestProps {
  totalPriceDataTestId?: string;
  itemPriceDataTestId?: string;
  quantityDataTestId?: string;
}

export const ServiceItem: ReactFCV<IServiceItemProps> = ({
  title,
  infoText,
  serviceActive,
  serviceDisabled,
  onClick,
  onBodyClick,
  pricePerPiece,
  pieces,
  price,
  additionalInfoComponent,
  unit = '',
  freePriceText,
  isDualPriceLayout,
  dataTestId,
  quantityDataTestId,
  totalPriceDataTestId,
  itemPriceDataTestId,
}) => {
  const onChildClick = useCallback(
    (event: React.MouseEvent) => {
      if (typeof onBodyClick === 'function') {
        onBodyClick();
      } else {
        onClick();
      }

      return preventDefaultMouseEvent(event);
    },
    [onBodyClick, onClick],
  );

  return (
    <CartLayout
      className={dataTestId}
      serviceActive={serviceActive}
      serviceDisabled={serviceDisabled}
      iconColumn={IconColumn(onClick)}
      bodyColumn={BodyColumn(title, onChildClick)}
      priceColumn={PriceColumn(totalPriceDataTestId, isDualPriceLayout, price, freePriceText)}
      infoColumn={InfoColumn(infoText, onChildClick)}
      additionalColumn={AdditionalColumn(additionalInfoComponent, onChildClick)}
      perPieceColumn={PerPieceColumn(pricePerPiece, itemPriceDataTestId, isDualPriceLayout)}
      piecesColumn={PiecesColumn(unit, pieces, quantityDataTestId)}
    />
  );
};
